import React, { Component } from 'react';
import { ref } from '../../../../config/constants';
import { Button, } from 'semantic-ui-react'

class DeleteOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ordersToDelete: [

                '-LQEReh4WNVe6PbY5tDk',
                '-LQESFDMcRyVM5MK7ta-',

            ]
        }
    }

    
    deleteOrders = () => {
        console.log("+++++++++: deleteOrders");


        for (var i = 0; i < this.state.ordersToDelete.length; i++) {
            console.log("deleting - :" + this.state.ordersToDelete[i]);
            ref.child('orders/' + this.state.ordersToDelete[i]).set(null);
            console.log("order deleted");
        }


    }

    render() {

        const deletedOrders = this.state.ordersToDelete.map((order) =>
            <h4>{order}</h4>
        )


        return (<div>
            {deletedOrders}
            <h3>num:{this.state.ordersToDelete.length}</h3>

            <Button onClick={this.deleteOrders}> Delete em</Button>

        </div>);
    }
}

export default DeleteOrders;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DeleteOrders/DeleteOrders.js